
import { RavRecord, RecordScope } from '#record/model';
import { Language } from 'apprise-core/language';
import { Wide } from 'apprise-ui/component/model';
import { FC, ReactNode } from 'react';




// a query is a set of conditions, indexed by the pill that collects them.
export type Query = {

    delisted: DelistedMode 
    mode: SearchMode
    conditions: Record<SearchKey,SearchCondition[]>
    scope: SearchScope

} 

// runs on a live pill's conditions when the query becomes a dto. a pill uses it to drop or rewrite criteria that
// do not apply to the query, which keeps them for when they apply again.
export type PreFlight = (conditions: SearchCondition[], query: Query) => SearchCondition[]

export type SearchScope = RecordScope | 'all'

export type SearchKey=string
export type SearchMode = 'current' | 'historical'

export type DelistedMode = 'include' | 'exclude'

// the mode a pill can belong to: one of the search modes, or 'delisted' for the searches that include
// delisted records, which are the historical ones and the current ones with the delisted toggle on.
export type PillMode = SearchMode | 'delisted'


export type SearchCondition = Record<string,any>
export type Sort = {field:string, mode: 'asc' | 'desc'}

export type HistoryItem = {
   
    timestamp: number
    query: Query
    total: number
}


export type SavedQuery = {
    name: string
    query: Query 
}




export type SearchDto = {

    language: Language
    mode: SearchMode
    scope: SearchScope
    conditions: SearchCondition[]
    includeDelisted: boolean
    sort: Sort[]
    cursor: SearchCursor
    total?: number      // set only after query is first run.
}

export type SearchCursor = Partial<{

    page: number
    pageSize: number


} | {

    offset: number
    limit: number
}>

export type ResultBatch = {

    results: RavRecord[]
    total: number

}


export type QueryFieldProps<T extends SearchCondition=SearchCondition> = Wide & Partial<{

    label: ReactNode
    onChange: (t:T | undefined) => void
    children: T

    disabled: boolean       // fields that honour it grey out and stop reporting changes.

    // the edited query's mode, for fields with criteria bound to it. a whole pill bound to a mode uses QueryPillProps.mode.
    mode: SearchMode
}>


export type QueryPillProps = {

    name: string
    label: string
    title: string
    field: FC<QueryFieldProps<any>>

    // the mode the pill belongs to, see isLive. outside it the pill is inert: it is not offered,
    // it greys out if it was already laid out, and it contributes no conditions.
    mode?:PillMode

    // the records the pill's field exists on, see isLive. in a search limited to the other records the pill
    // is inert, as outside its mode: external records carry no authorization, so its filters cannot apply there.
    scope?: RecordScope
    repeatable?:boolean

    defaultLayout?: boolean

    preFlight? : PreFlight
}


// historical searches include delisted records, current searches only when the delisted toggle is on.
// the dto's includeDelisted and the liveness of 'delisted' pills both read this, so the two cannot drift apart:
// a delisting reason sent with delisted records excluded would match nothing, silently.
export const includesDelisted = (q: Query) => q.mode === 'historical' || q.delisted === 'include'

// a pill is live when the query is in the pill's mode and reaches the pill's records, and always when it declares
// neither. a query reaches the pill's records unless it is limited to the other scope: 'all' reaches every record.
// a pill missing from the registry declares nothing, so it counts as live.
export const isLive = (p: QueryPillProps | undefined, q: Query) =>
    (!p?.mode || (p.mode === 'delisted' ? includesDelisted(q) : p.mode === q.mode))
    && (!p?.scope || q.scope === 'all' || p.scope === q.scope)


export const QueryPill = (_: QueryPillProps & {

}) => {

    return null;
}